import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FormattedMessage } from '~/techstyle-shared/react-intl';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  flex: 1;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 186px 0px;
  gap: 4px;
`;

const Title = styled.h2`
  display: block;
  font-size: 1.5em;
  margin-block-start: 0.83em;
  margin-block-end: 0.83em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: bold;
  unicode-bidi: isolate;
  margin: 0;
  padding: 0;
  line-height: 1.2;
  font-weight: bold;
  white-space: pre-wrap;
`;

const Description = styled.p`
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  unicode-bidi: isolate;
  margin: 0;
  padding: 0;
  font-size: 1em;
  line-height: 1.2;
  white-space: pre-wrap;
  padding-bottom: 28px;
`;

const FilterButton = styled.button`
  position: relative;
  font-family: inherit;
  font-size: 1rem;
  font-weight: normal;
  text-decoration: none;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  vertical-align: middle;
  width: auto;
  min-width: fit-content;
  opacity: 1;
  border-radius: 4px;
  padding: 12px 18px;
  transition:
    background-color 0.16s ease-in-out,
    border-color 0.16s ease-in-out;
  background: rgb(27, 28, 25);
  border: 1px solid rgb(27, 28, 25);
  text-transform: uppercase;
  color: rgb(255, 255, 255);
  & span {
    font-weight: 600;
    font-size: 16px;
    line-height: 1.25;
    font-family: inherit;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: normal;
    gap: 8px;
    color: rgb(255, 255, 255);
  }
`;

const NoResultsFound = ({
  description,
  title,
  buttonLabel,
  isDesktop = true,
  onClickButton = () => {},
}) => {
  return (
    <Wrapper>
      <TextWrapper data-autotag="grid-empty-msg" isDesktop={isDesktop}>
        <Title>
          {title || (
            <FormattedMessage
              id="site_product_grid.no_products_title"
              defaultMessage="Hmmm..."
            />
          )}
        </Title>
        <Description>
          {description || (
            <FormattedMessage
              id="site_product_grid.no_products_description"
              defaultMessage="We couldn't find any matching items"
            />
          )}
        </Description>
        {!isDesktop && (
          <FilterButton
            data-autotag="filter-change-cta"
            onClick={onClickButton}
          >
            {buttonLabel || (
              <FormattedMessage
                id="site_product_grid.no_products_cta_label"
                defaultMessage="Change Filters"
              />
            )}
          </FilterButton>
        )}
      </TextWrapper>
    </Wrapper>
  );
};

NoResultsFound.propTypes = {
  buttonLabel: PropTypes.string,
  description: PropTypes.string,
  isDesktop: PropTypes.bool,
  onClickButton: PropTypes.func,
  title: PropTypes.string,
};

export default NoResultsFound;
